export default from './block-member-modal';



// WEBPACK FOOTER //
// ./app/containers/block-member-modal/index.js